<template>
  <div class="schedule-slot">
    <div class="datepicker">
      <p class="input-label">
        {{ trans('global.date') }}
        <span
          v-if="required"
        >
          &nbsp;*
        </span>
      </p>
      <vue-date-picker
        v-model="schedule.date"
        class="input-text"
        name="schedule-slot[date]"
        :format="options.format"
        :max-date="getMaxDate"
        locale="fr"
        :enable-time-picker="false"
        auto-apply
        @update:model-value="onDateChanged(arguments[0])"
        @open="onDateTimeComponentDisplayChange('datepicker-opened')"
        @closed="onDateTimeComponentDisplayChange('datepicker-closed')"
      >
        <template #input-icon>
          <span class="datepicker__icon datepicker__icon--datepicker" />
        </template>
      </vue-date-picker>
    </div>
    <div class="timepicker">
      <p class="input-label">
        {{ trans('global.timeslot') }}
        <span
          v-if="required"
        >
          &nbsp;*
        </span>
      </p>
      <timeslot
        @time-changed="onTimeChanged"
      />
    </div>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import timeslot from '@components/timeslot.vue';
import translation from '@elements/translation';
import { getYesterdayDate } from '@tools/date';

export default {
  components: {
    VueDatePicker,
    timeslot,
  },
  mixins: [ translation ],
  props: {
    required: { type: Boolean, default: false },
    beforeLimit: { type: Boolean, default: false },
  },
  data() {
    return {
      options: {
        format: 'dd/MM/yyyy',
      },
      schedule: {
        date: null,
        time: null,
      },
    };
  },
  computed: {
    isSlotValid() {
      return (
        this.schedule.date !== null
        && this.schedule.time !== null
        && this.schedule.time.HH !== ''
        && this.schedule.time.mm !== ''
      );
    },
    yesterdayDate() {
      return getYesterdayDate();
    },
    getMaxDate() {
      if (this.beforeLimit) {
        return this.yesterdayDate;
      }
      return null;
    },
  },
  methods: {
    onDateTimeComponentDisplayChange(eventName) {
      this.$emit(eventName);
    },
    onTimeChanged(time) {
      this.schedule.time = time;
      this.changed();
    },
    onDateChanged() {
      this.changed();
    },
    changed() {
      this.$emit('changed', { schedule: this.schedule, isSlotValid: this.isSlotValid });
    },
  },
};
</script>
